import { memo, useCallback, useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BzModal, BzModalHeader, BzModalBody, BzModalFooter, BzButton, BzModalTitle } from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal, handleModalData } from '../../../redux/actions/modals';
import ConfirmationBody from './ConfirmationBody';
import { ALL_ORDERS_STATUS, API_CODES, API_RESPONSE_STATUS, APP_INFO_PARAMS, DEPOSITORY_CDSL, DEPOSITORY_NSDL, LAYOUT_TYPE, LOCATIONS, MAPPED_MARKET_SEGMENT_ID, MARKET_SEGMENT_ID, NETWORK_RESPONSE_STATUS, ORDERBOOK_API_ORDER_STATUS, ORDERS_LIMIT_IN_API, ORDERS_TABKEY, ORDER_ENTRY_BUTTON_TOGGLE, ORDER_ENTRY_TYPES, ORDER_PRODUCT_TYPES, ORDER_TYPES, ORDER_VALIDITY, SCRIP_INSTRUMENTS, SEGMENT_CASH, WATCHLIST_GRID_INDEX } from '../../../utils/global_variables';
import { ORDERS_GRID_REF, collapseRow, getApiExchangeNameFromMktSegId, getAppInfoData, getOrderIdentifier, hasUserGrantedPOA } from '../../../utils/global_functions';
import { getAllGtdOrders, getAllOrders, getAllSipOrders, getMarketStatusFailure, getplaceMultilegOrderFailure, modifyBracketOrder, modifyCoverOrder, modifyOrder, modifySpread, orderMarginInfoFailure, placeMultilegOrderAction, placeSingleScripBracketOrder, placeSingleScripCoverOrder, placeSingleScripOrder, placeSingleScripOrderSuccess, placeSipOrder, updateMultiScripaddLEgModalTabKeyAction, updateSipOrder } from '../../../redux/actions/orders';
import moment from 'moment';
import { toastConfig } from '../../../redux/actions/toast';
import { createOrderCartInfo, saveCartForGoback, saveCartSuccess, storeGridData } from '../../../redux/actions/orderCart';
import { getEDISSummaryDetails } from '../../../redux/actions/edis';
import Edis from '../../../screens/Edis';
import dayjs from 'dayjs';
import FocusLock from 'react-focus-lock';
import { useLocation } from 'react-router';
import { getInteropConfigurationDetails } from '../../../redux/actions/auth';
import { getMessagesOrders } from '../../../redux/actions/messages';
import { updateBasketReco, updateCartCount } from '../../../redux/actions/recommendation';

const isHistoryAllowed = true;
let objOrderStatusScripData = {};
const ConfirmationModal = (props) => {
    const { setToggleBracketOrder, setOrderInputs, setLegDataInfo, setThirdLegData, setSelectOrderOption, setOrderEntryTab, marginInfoHandler, defaultGtdDate, activeContent,
        //  Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
        ordersTabKey,
        //  Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
        layoutType //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - Start
    } = props;
    const dispatch = useDispatch();
    //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
    const currentDate = new Date().toLocaleDateString("en-CA").split("/").reverse().join('-');
    //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End

    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    const [bIsConfirmBtn, setBIsConfirmBtn] = useState(true);

    const modals = useSelector(state => state.modals.modals);
    const { data: { orderEntryTab, activeTabKey, orderData, isModifyOrder, isReOrder,
        activeButtonToggleIndex = ORDER_ENTRY_BUTTON_TOGGLE.BUY, scripOrderInfo, GTDNoOfDays, bIsCoverBracketOrderOpen = false,
        selectOrderOption = {}, nOrderValue = -1, orderInputs = {}, objSelectOrderOptionInit = {}, arrInfo = [], arrOrderSlicingInfo = [], validatedTriggerPrice } } = useSelector(state => state?.modals?.modalData);

    const objSingleScripOrderResp = useSelector(state => state.orders.singleScripOrder);
    const objModalData = useSelector(state => state?.modals?.modalData);
    const arrOrderDetails = objModalData?.data?.orderCartConfirmation?.data?.orderCartInfo;
    const objSipOrderResp = useSelector(state => state.orders.sipOrder);
    const bIsOrderEntryApiPending = useSelector(state => state.orders.bIsOrderEntryApiPending);//Azeem K : 26-03-2024 : BT-102298 - Breeze - Single Scrip Order entry -Loader added on order entry
    const objMultiLegOrderResp = useSelector(state => state.orders.placeMultilegOrder);
    // Ajitesh - 19/01/2024 - eDIS order cart implementation start
    const edisSummaryDetails = useSelector(state => state.edis.edisSummaryDetails);
    const interopConfigDetails = useSelector(state => state.auth.interopConfig); // interop data to make edis scrips summary api call
    const userDpDetails = useSelector(state => state.auth.dpDetails);
    const [orderCartScripsForEdis, setOrderCartScripsForEdis] = useState([]);
    const [amoScripResponse, setAmoScripResponse] = useState([]);
    // Ajitesh - 19/01/2024 - eDIS order cart implementation end
    const location = useLocation();


    useEffect(() => {
        if (!interopConfigDetails.length) {
            dispatch(getInteropConfigurationDetails());
        }
    }, [dispatch, interopConfigDetails]);


    const handleClose = () => {
        //Maaz A : 23-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FnO Bug Fixes - Start
        dispatch(placeSingleScripOrderSuccess({}));
        //Maaz A : 23-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FnO Bug Fixes - End
        setToggleBracketOrder(curr => ({ ...curr, isShow: false }));
        //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
        dispatch(toastConfig({ show: false }));
        setOrderInputs({ scripQuantity: 1, scripLot: 1, scripAmount: 0, scripPrice: '', slTrigger: 0, quantity: 0, capPrice: 0, numberOfInstallment: 0, intradayTrigger: 0, intradayLimit: 0, intradayTrailing: 0, intradayProfit: 0, discQty: 0, protPercent: 0, startDate: currentDate, gtdDate: defaultGtdDate, targetSelPrice: 0, targetSelTriggerPrice: 0 });// Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) 
        //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
        setLegDataInfo([]);
        //Maaz A : 17-11-2023 : Client Facility Template - Added for MultiLeg and Spread - Start
        // setOrderEntryTab(orderEntryTab || ORDER_TYPES.SINGLE_SCRIP);
        // if (activeTabKey) {
        //     setActiveTabKey(activeTabKey);
        // }
        //Maaz A : 17-11-2023 : Client Facility Template - Added for MultiLeg and Spread - End
        setThirdLegData([]);
        setSelectOrderOption(objSelectOrderOptionInit);
        dispatch(orderMarginInfoFailure(null));
        // dispatch(handleModalData({}));
        dispatch(getMarketStatusFailure([]));
        dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': false }]));
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - Start
        dispatch(saveCartSuccess(false));
        dispatch(saveCartForGoback({}));
        dispatch(storeGridData([]));
        dispatch(getplaceMultilegOrderFailure([])); // Important
        { orderEntryTab === ORDER_TYPES.MULTI_SCRIP && (activeTabKey === ORDER_TYPES.BASKET || activeTabKey === ORDER_TYPES.SPREAD) && dispatch(handleModalData({ data: { ...objModalData.data, gatewayOrderNo: objModalData?.data?.scripOrderInfo?.gatewayOrderNo, orderTime: objModalData?.data?.scripOrderInfo?.orderTime, isGoBack: true, orderEntryTab: ORDER_TYPES.MULTI_SCRIP, orderEntryTab } })); }; //BT-106965 : Ordercart : GoBack issue in confirmation modal : ManasaB : 03-05-2024
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - End
    };
    const handleGoBack = useCallback(() => {
        //Maaz A : 23-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FnO Bug Fixes - Start
        dispatch(placeSingleScripOrderSuccess({}));
        setSelectOrderOption(curr => ({ ...curr, isDefaultProductType: false }));
        dispatch(getplaceMultilegOrderFailure([])); // Important
        //Maaz A : 23-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSE FnO Bug Fixes - End
        if (layoutType === LAYOUT_TYPE.HORIZONTAL) {
            //BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : Start
            if (objModalData?.data?.orderFrom !== 'BASKETRECO') {
                dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }, { 'ORDER_ENTRY_CONFIRMATION': false }], true));
                if (orderEntryTab === ORDER_TYPES.MULTI_SCRIP && (activeTabKey === ORDER_TYPES.BASKET || activeTabKey === ORDER_TYPES.SPREAD)) {
                    dispatch(handleModalData({ data: { ...objModalData.data, gatewayOrderNo: objModalData?.data?.scripOrderInfo?.gatewayOrderNo, orderTime: objModalData?.data?.scripOrderInfo?.orderTime, isGoBack: true, orderEntryTab: ORDER_TYPES.MULTI_SCRIP } }));  //BT-106965 : Ordercart : GoBack issue in confirmation modal : ManasaB : 03-05-2024
                }
                dispatch(handleModalData({ data: { ...objModalData.data, isGoback: true } }));
            }
            else {
                dispatch(handleModal([{ 'RECOMMENDATION_CART_MODAL': true }, { 'ORDER_ENTRY_CONFIRMATION': false }], true));
                dispatch(handleModalData({ data: { isGoback: true } }));
            }
        } else {
            dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': false }]));
        }
        //BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : End
        setOrderEntryTab(orderEntryTab);
    }, [activeTabKey, dispatch, layoutType, objModalData, orderEntryTab, setOrderEntryTab, setSelectOrderOption]);

    const handleOnConfirmSingleScripOrder = () => {
        if (scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_DERIVATIVES || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES
            //Azeem K : 01-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSE FnO Bug Fixes - Start
            || scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSE_DERIVATIVES) {
            //Azeem K : 01-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSE FnO Bug Fixes - End
            var nQuantity = orderInputs.scripQuantity;
        } else {
            nQuantity = orderInputs.scripLot;
        }
        //Azeem K : 23-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NCDEX bug fixing - Start
        let nDiscQty = orderInputs?.discQty;
        if (scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES) {
            nDiscQty = orderInputs?.discQty * scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT];
        }
        //Azeem K : 23-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - NCDEX bug fixing - End
        if (scripOrderInfo?.length > 0) {
            if (isModifyOrder) {
                //  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start 
                const strExchange = orderData?.exchangeSegment || orderData?.exchange;
                if (bIsCoverBracketOrderOpen) {

                    const nIntradayTrigger = parseFloat(orderInputs?.intradayTrigger);
                    //  Azeem K : 29-04-2025 : BREEZE-6539 - Breeze - Bracket Orders - Start
                    if (!isNaN(parseFloat(orderInputs?.intradayProfit)) && parseFloat(orderInputs?.intradayProfit) > 0) {
                        const objBarcketModificationPayload = {
                            main_leg: {

                                traded_quantity: orderData?.tradedQuantity || orderData?.traded_quantity || 0,
                                order_type: selectOrderOption?.orderType,
                                quantity: nQuantity,
                                price: parseFloat(orderInputs?.scripPrice) && selectOrderOption?.orderType === ORDER_ENTRY_TYPES.RL ? parseFloat(orderInputs?.scripPrice) : 0,
                                trigger_price: 0,
                            },
                            stoploss_leg: {
                                legs: [
                                    {
                                        quantity: 0,
                                        price: parseFloat(orderInputs?.intradayLimit) ? parseFloat(orderInputs?.intradayLimit) : 0,
                                        trigger_price: nIntradayTrigger
                                    }
                                ],
                                trail: {
                                    ltp_jump_price: parseFloat(orderInputs?.IntradayChangePrice) ? parseFloat(orderInputs?.IntradayChangePrice) : 0,
                                    stoploss_jump_price: parseFloat(orderInputs?.intradayTrailing) ? parseFloat(orderInputs?.intradayTrailing) : 0,
                                }
                            },
                            profit_leg: {
                                legs: [
                                    {
                                        quantity: 0,
                                        price: parseFloat(orderInputs?.intradayProfit) ? parseFloat(orderInputs?.intradayProfit) : 0
                                    }
                                ]
                            },
                            fields_modified: {
                                main_leg_price: parseFloat(orderInputs?.scripPrice) !== parseFloat(orderData?.price) || selectOrderOption?.orderType !== orderData?.order_type,
                                main_leg_qty: parseInt(nQuantity) !== parseInt(orderData?.pending_quantity),
                                stoploss_leg_price: parseFloat(orderInputs?.intradayTrigger) !== parseFloat(orderData?.bracket_details?.stoploss_trigger_price),
                                stoploss_trail_price: parseFloat(orderData?.bracket_details?.stoploss_jump_price) ? parseFloat(orderInputs?.intradayTrailing) !== parseFloat(orderData?.bracket_details?.intradayTrailing) : false,
                                profit_leg_price: parseFloat(orderInputs?.intradayProfit) !== parseFloat(orderData?.bracket_details?.profit_price)
                            },
                            order_time: orderData?.date + " " + orderData?.time,
                        };
                        dispatch(modifyBracketOrder(objBarcketModificationPayload, strExchange, encodeURI(orderData?.orderNo))).then((objResp) => {
                            setTimeout(() => {

                                if (objResp?.data?.code === API_CODES.ECODE_SUCCESS) {
                                    if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
                                        dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }));
                                    } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
                                        dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }));
                                    }
                                }
                                dispatch(handleModal([{ 'ORDER_STATUS': false }]));
                            }, 2000);
                            dispatch(handleModalData({ data: { orderEntryTab, isModifyOrder, scripOrderInfo } }));
                            dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': false }, { 'ORDER_STATUS': true }], true));
                            setOrderInputs({ scripQuantity: 1, scripLot: 1, scripAmount: 0, scripPrice: '', slTrigger: 0, quantity: 0, capPrice: 0, numberOfInstallment: 0, intradayTrigger: 0, intradayLimit: 0, intradayTrailing: 0, intradayProfit: 0, discQty: 0, protPercent: 0, startDate: currentDate, gtdDate: defaultGtdDate, targetSelPrice: 0, targetSelTriggerPrice: 0, IntradayChangePrice: 0 });
                            collapseRow(ORDERS_GRID_REF, false, 'orderNo', orderData);

                        });
                        //  Azeem K : 29-04-2025 : BREEZE-6539 - Breeze - Bracket Orders - End
                    } else if ((!isNaN(nIntradayTrigger) && nIntradayTrigger > 0) || orderData?.product_type == ORDER_PRODUCT_TYPES.COVER) {
                        //cover order modification

                        const objCoverModificationPayload = {
                            "main_leg": {
                                "order_type": selectOrderOption?.orderType,
                                "quantity": nQuantity,
                                "traded_quantity": orderData?.tradedQuantity || orderData?.traded_quantity || 0,
                                "price": selectOrderOption?.orderType === ORDER_ENTRY_TYPES.SL || selectOrderOption?.orderType === ORDER_ENTRY_TYPES.RL ? parseFloat(orderInputs?.scripPrice) : 0

                            },
                            "stoploss_leg": {
                                "legs": [
                                    {
                                        "quantity": nQuantity,
                                        "price": parseFloat(orderInputs?.intradayLimit) ? parseFloat(orderInputs?.intradayLimit) : 0,
                                        "trigger_price": nIntradayTrigger,
                                        "trigger_price_validation": !validatedTriggerPrice
                                    }
                                ]
                            },
                            "order_time": orderData?.date + " " + orderData?.time,
                            "leg_indicator": orderData?.leg_indicator_num,
                        };
                        let validate = (orderData?.product_type == ORDER_PRODUCT_TYPES.COVER && isModifyOrder && orderData?.orderType === ORDER_ENTRY_TYPES.RL && parseFloat(orderData.leg_indicator_num) == 2 && parseFloat(orderInputs?.intradayLimit) == 0) ? false : true;
                        if (!validate) {
                            objCoverModificationPayload["stoploss_leg"]["legs"][0]["order_type"] = ORDER_ENTRY_TYPES.RL_MKT;
                        }

                        dispatch(modifyCoverOrder(objCoverModificationPayload, strExchange, encodeURI(orderData?.orderNo))).then((objResp) => {
                            setTimeout(() => {

                                if (objResp?.data?.code === API_CODES.ECODE_SUCCESS) {
                                    if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
                                        dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }));
                                    } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
                                        dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }));
                                    }
                                }
                                dispatch(handleModal([{ 'ORDER_STATUS': false }]));
                            }, 2000);
                            dispatch(handleModalData({ data: { orderEntryTab, isModifyOrder, scripOrderInfo } }));
                            dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': false }, { 'ORDER_STATUS': true }], true));
                            setOrderInputs({ scripQuantity: 1, scripLot: 1, scripAmount: 0, scripPrice: '', slTrigger: 0, quantity: 0, capPrice: 0, numberOfInstallment: 0, intradayTrigger: 0, intradayLimit: 0, intradayTrailing: 0, intradayProfit: 0, discQty: 0, protPercent: 0, startDate: currentDate, gtdDate: defaultGtdDate, targetSelPrice: 0, targetSelTriggerPrice: 0 });
                            collapseRow(ORDERS_GRID_REF, false, 'orderNo', orderData);

                        });
                    }
                    //  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - End 
                } else {
                    const objPayLoad = {
                        "order_type": selectOrderOption?.orderType,
                        "quantity": nQuantity,
                        "price": selectOrderOption?.orderType === ORDER_ENTRY_TYPES.SL || selectOrderOption?.orderType === ORDER_ENTRY_TYPES.RL ? parseFloat(orderInputs?.scripPrice) : 0,
                        "trigger_price": selectOrderOption?.orderType?.includes(ORDER_ENTRY_TYPES.SL) || selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT ? parseFloat(orderInputs?.slTrigger) : 0,//BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -Start
                        "disclosed_quantity": parseInt(nDiscQty),
                        "validity": selectOrderOption?.validityTypes,
                        'validity_days': selectOrderOption?.validityTypes === ORDER_VALIDITY.GTD ? GTDNoOfDays : 0,
                        "traded_quantity": orderData?.tradedQuantity || orderData?.traded_quantity || 0,// Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue - modify order not working
                        "order_time": orderData?.date + " " + orderData?.time //"2023-10-05 15:57:29",

                    };
                    // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --Start 
                    if (selectOrderOption?.isOCOChecked) {
                        objPayLoad.price_firstleg = parseFloat(orderInputs?.targetSelPrice);
                        objPayLoad.price_secondleg = parseFloat(orderInputs?.targetSelTriggerPrice);
                    }
                    // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --End
                    //Maaz A : 10-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
                    dispatch(modifyOrder(objPayLoad, strExchange, encodeURI(orderData?.orderNo))).then((objResp) => {// Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue - modify order not working
                        //Maaz A : 10-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
                        //Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                        setTimeout(() => {

                            if (objResp?.data.code === API_CODES.ECODE_SUCCESS) {
                                if (activeContent === ORDER_TYPES.SINGLE_SCRIP) {
                                    if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
                                        dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }));
                                    } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
                                        dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }));
                                    }
                                    //Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
                                } else if (activeContent === ORDER_TYPES.GOOD_TILL_DATE) {
                                    if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
                                        dispatch(getAllGtdOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }));

                                    } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
                                        dispatch(getAllGtdOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }));
                                    }
                                    //Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
                                }
                            }
                            dispatch(handleModal([{ 'ORDER_STATUS': false }]));

                        }, 2000);
                        dispatch(handleModalData({ data: { orderEntryTab, isModifyOrder, scripOrderInfo } }));
                        dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': false }, { 'ORDER_STATUS': true }], true));
                        setOrderInputs({ scripQuantity: 1, scripLot: 1, scripAmount: 0, scripPrice: '', slTrigger: 0, quantity: 0, capPrice: 0, numberOfInstallment: 0, intradayTrigger: 0, intradayLimit: 0, intradayTrailing: 0, intradayProfit: 0, discQty: 0, protPercent: 0, startDate: currentDate, gtdDate: defaultGtdDate, targetSelPrice: 0, targetSelTriggerPrice: 0 });   // Azeem K : 07-05-2024 : BT-102298 Order Entry Production issues solved
                        collapseRow(ORDERS_GRID_REF, false, 'orderNo', orderData);

                    });
                }
            } else {
                const exchangeNameById = getApiExchangeNameFromMktSegId(scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
                if (selectOrderOption?.productType === ORDER_PRODUCT_TYPES.MARGIN) {
                    var strSelProductType = ORDER_PRODUCT_TYPES.INTRADAY;
                } else if (selectOrderOption?.productType === ORDER_PRODUCT_TYPES.CARRYFORWARD) {
                    strSelProductType = ORDER_PRODUCT_TYPES.DELIVERY;
                } else if (selectOrderOption?.productType === ORDER_PRODUCT_TYPES.PTST) {
                    strSelProductType = ORDER_PRODUCT_TYPES.BTST;
                } else {
                    strSelProductType = selectOrderOption?.productType;
                }

                if (bIsCoverBracketOrderOpen) {

                    const nIntradayProfit = parseFloat(orderInputs?.intradayProfit);
                    const nIntradayTrigger = parseFloat(orderInputs?.intradayTrigger);

                    // for order status
                    objOrderStatusScripData = {
                        scrip_info: {
                            exchange: exchangeNameById,
                            scrip_token: scripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN],
                            symbol: scripOrderInfo[WATCHLIST_GRID_INDEX.SYMBOL],
                            series: scripOrderInfo[WATCHLIST_GRID_INDEX.SERIES],
                            expiry_date: scripOrderInfo[WATCHLIST_GRID_INDEX.EXPIRYDATE],
                            strike_price: scripOrderInfo[WATCHLIST_GRID_INDEX.STRIKEPRICE],
                            option_type: scripOrderInfo[WATCHLIST_GRID_INDEX.OPTIONTYPE]

                        },
                        transaction_type: activeButtonToggleIndex === 0 ? 'BUY' : 'SELL',
                        product_type: strSelProductType,
                        order_type: selectOrderOption?.orderType,
                        quantity: nQuantity,
                        price: parseFloat(orderInputs?.scripPrice),
                        trigger_price: 0,
                        intradayTrigger: nIntradayTrigger,
                        intradayProfit: nIntradayProfit,
                        intradayLimit: parseFloat(orderInputs?.intradayLimit),
                        intradayTrailing: parseInt(orderInputs?.intradayTrailing),
                        IntradayChangePrice: parseInt(orderInputs?.IntradayChangePrice),
                        coverOrBracket: '',
                        orderEntryTab: orderEntryTab,
                    };


                    if (!isNaN(nIntradayProfit) && nIntradayProfit > 0) {
                        // Bracker Order Request
                        objOrderStatusScripData.coverOrBracket = ORDER_PRODUCT_TYPES.BRACKET;
                        const objBracketOrderRequest = {
                            scrip_info: {
                                exchange: exchangeNameById,
                                scrip_token: scripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN],
                                symbol: scripOrderInfo[WATCHLIST_GRID_INDEX.SYMBOL],
                                series: scripOrderInfo[WATCHLIST_GRID_INDEX.SERIES],
                                expiry_date: scripOrderInfo[WATCHLIST_GRID_INDEX.EXPIRYDATE],
                                strike_price: scripOrderInfo[WATCHLIST_GRID_INDEX.STRIKEPRICE],
                                option_type: scripOrderInfo[WATCHLIST_GRID_INDEX.OPTIONTYPE]
                            },
                            transaction_type: activeButtonToggleIndex === 0 ? 'BUY' : 'SELL',
                            main_leg: {
                                order_type: selectOrderOption?.orderType,
                                quantity: nQuantity,
                                price: parseFloat(orderInputs?.scripPrice) ? parseFloat(orderInputs?.scripPrice) : 0,
                                trigger_price: 0,
                            },
                            stoploss_leg: {
                                legs: [
                                    {
                                        quantity: nQuantity,
                                        price: parseFloat(orderInputs?.intradayLimit) ? parseFloat(orderInputs?.intradayLimit) : 0,
                                        trigger_price: nIntradayTrigger
                                    }
                                ],
                                trail: {
                                    ltp_jump_price: parseFloat(orderInputs?.IntradayChangePrice) ? parseFloat(orderInputs?.IntradayChangePrice) : 0,
                                    stoploss_jump_price: parseFloat(orderInputs?.intradayTrailing) ? parseFloat(orderInputs?.intradayTrailing) : 0,
                                }
                            },
                            profit_leg: {
                                legs: [
                                    {
                                        quantity: nQuantity,
                                        price: nIntradayProfit,
                                    }
                                ]
                            },
                            order_identifier: getOrderIdentifier(),
                        };

                        dispatch(placeSingleScripBracketOrder(objBracketOrderRequest));

                    } else if (!isNaN(nIntradayTrigger) && nIntradayTrigger > 0) {
                        // Cover Order Request
                        objOrderStatusScripData.coverOrBracket = ORDER_PRODUCT_TYPES.COVER;
                        const objCoverOrderRequest = {
                            scrip_info: {
                                exchange: exchangeNameById,
                                scrip_token: scripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN],
                                symbol: scripOrderInfo[WATCHLIST_GRID_INDEX.SYMBOL],
                                series: scripOrderInfo[WATCHLIST_GRID_INDEX.SERIES],
                                expiry_date: scripOrderInfo[WATCHLIST_GRID_INDEX.EXPIRYDATE],
                                strike_price: scripOrderInfo[WATCHLIST_GRID_INDEX.STRIKEPRICE],
                                option_type: scripOrderInfo[WATCHLIST_GRID_INDEX.OPTIONTYPE]
                            },
                            transaction_type: activeButtonToggleIndex === 0 ? 'BUY' : 'SELL',
                            main_leg: {
                                order_type: selectOrderOption?.orderType,
                                quantity: nQuantity,
                                price: parseFloat(orderInputs?.scripPrice) ? parseFloat(orderInputs?.scripPrice) : 0,
                            },
                            stoploss_leg: {
                                legs: [
                                    {
                                        quantity: nQuantity,
                                        price: parseFloat(orderInputs?.intradayLimit) ? parseFloat(orderInputs?.intradayLimit) : 0,
                                        trigger_price: nIntradayTrigger
                                    }
                                ]
                            },
                            order_identifier: getOrderIdentifier(),
                        };
                        dispatch(placeSingleScripCoverOrder(objCoverOrderRequest));
                    } else { }
                } else {
                    const objSingleScripRequest = {
                        scrip_info: {
                            exchange: exchangeNameById,
                            scrip_token: scripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN],
                            symbol: scripOrderInfo[WATCHLIST_GRID_INDEX.SYMBOL],
                            series: scripOrderInfo[WATCHLIST_GRID_INDEX.SERIES],
                            expiry_date: scripOrderInfo[WATCHLIST_GRID_INDEX.EXPIRYDATE],
                            strike_price: scripOrderInfo[WATCHLIST_GRID_INDEX.STRIKEPRICE],
                            option_type: scripOrderInfo[WATCHLIST_GRID_INDEX.OPTIONTYPE]
                        },
                        transaction_type: activeButtonToggleIndex === 0 ? 'BUY' : 'SELL',
                        product_type: strSelProductType,
                        order_type: selectOrderOption?.orderType,
                        quantity: nQuantity,
                        price: selectOrderOption?.orderType === ORDER_ENTRY_TYPES.SL || selectOrderOption?.orderType === ORDER_ENTRY_TYPES.RL ? parseFloat(orderInputs?.scripPrice) : 0,
                        trigger_price: selectOrderOption?.orderType?.includes(ORDER_ENTRY_TYPES.SL) || selectOrderOption?.validityTypes === ORDER_VALIDITY.GTT ? parseFloat(orderInputs?.slTrigger) : 0,//BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 -Start
                        disclosed_quantity: parseInt(nDiscQty),
                        validity: selectOrderOption?.validityTypes,
                        validity_days: selectOrderOption?.validityTypes === ORDER_VALIDITY.GTD ? GTDNoOfDays : 0,
                        is_amo: selectOrderOption?.isAmo,
                        order_identifier: getOrderIdentifier(),
                        orderEntryTab: orderEntryTab,
                    };
                    // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --Start 
                    if (selectOrderOption?.isOCOChecked) {
                        objSingleScripRequest.price_firstleg = parseFloat(orderInputs?.targetSelPrice);
                        objSingleScripRequest.price_secondleg = parseFloat(orderInputs?.targetSelTriggerPrice);
                    }
                    // Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other) --End
                    objSingleScripRequest["freeze_quantity"] = arrOrderSlicingInfo?.length > 0 ? scripOrderInfo[WATCHLIST_GRID_INDEX.MAX_SINGLE_TRANSACTION_QTY] : 0; //BT-138033 : Order Slicing: ManasaB : 26-06-2024 
                    objOrderStatusScripData = objSingleScripRequest;
                    dispatch(placeSingleScripOrder(objSingleScripRequest));
                }

                // setIsChecked(!isChecked);

            }
            //Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
            if ((isReOrder || location.pathname === LOCATIONS.ORDERS) && !isModifyOrder) {
                setTimeout(() => {
                    if (activeContent === ORDER_TYPES.SINGLE_SCRIP) {
                        if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
                            dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }));
                        } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
                            dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }));
                        } else if (ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS) {
                            dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.COMPLETED_ORDERS }));
                        }
                    } else if (activeContent === ORDER_TYPES.GOOD_TILL_DATE) {
                        if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
                            dispatch(getAllGtdOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }));
                        } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
                            dispatch(getAllGtdOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }));
                        } else if (ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS) {
                            dispatch(getAllGtdOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.COMPLETED_ORDERS }));
                        }
                    }
                }, 3000);
                collapseRow(ORDERS_GRID_REF, false, 'orderNo', orderData);
            }
            //Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
        }

    };

    const handleOnCofirmSipOrder = () => {
        // {/* Vinit Raut : 25-04-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 -- Start  */ }
        const frequencySpecificDate = dayjs(orderInputs?.startDate)?.format('DD-MM-YYYY');
        // {/* Vinit Raut : 25-04-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 -- End  */ }

        // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
        if (isModifyOrder) {
            // {/* Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 -- Start  */ }
            const objPayload = {
                scrip_info: {
                    exchange: orderData?.exchangeSegment,
                    scrip_token: orderData?.scrip_token,
                    symbol: orderData?.symbol,
                    series: orderData?.series,
                    expiry_date: '',
                    strike_price: '',
                    option_type: '',
                },
                frequency_details: {
                    frequency_type: selectOrderOption?.frequency,
                    frequency_days: selectOrderOption?.everyForWeekly,   // BT-107418 - Vinit R - 28/03/2024 Breeze SIP order Book
                    frequency_start_date: frequencySpecificDate,         // Vinit Raut : 25-04-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing
                    frequency_specific_date: selectOrderOption?.selectSpecificFrequencyDate,  // BT-107418- 15/04/2024 - Vinit R - 28/03/2024 Breeze SIP order entry issues
                    frequency_monthly_option: selectOrderOption?.frequency,
                    no_of_installments: parseInt(orderInputs?.numberOfInstallment)
                },
                company_name: "",
                ltp: scripOrderInfo?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE],
                cap_price: String(orderInputs?.capPrice),
                invested_by: selectOrderOption?.orderBy === "Amount" ? "VALUE" :
                    selectOrderOption?.orderBy.toUpperCase(),
                quantity_or_value: String(orderInputs?.quantity),
                transaction_type: activeButtonToggleIndex === 0 ? 'BUY' : 'SELL',
                status: orderData?.updated_status,
                basket_name: "",
                sip_id: orderData?.id,
            };
            // {/* Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 -- End */ }
            dispatch(updateSipOrder(objPayload)).then((objResp) => {
                if (objResp?.data.data.code === API_CODES.ECODE_SUCCESS) {

                    if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
                        dispatch(getAllSipOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }, isHistoryAllowed));
                    } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
                        dispatch(getAllSipOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }, isHistoryAllowed));
                    }
                    dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': false }]));
                } else {
                    dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': false }]));
                }
                setOrderEntryTab(ORDER_TYPES.SINGLE_SCRIP);
            });
            // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
        } else {

            const objSipReqPayload = {
                scrip_info: {
                    exchange: getApiExchangeNameFromMktSegId(scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID]),
                    scrip_token: scripOrderInfo?.[WATCHLIST_GRID_INDEX.TOKEN],
                    symbol: scripOrderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL],
                    series: scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES],
                    expiry_date: "",
                    strike_price: "",
                    option_type: ""
                },
                // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 -- Start
                frequency_details: {
                    frequency_type: selectOrderOption?.frequency,
                    frequency_days: selectOrderOption?.everyForWeekly,   // BT-107418 - Vinit R - 28/03/2024 Breeze SIP order Book
                    frequency_start_date: frequencySpecificDate, // Vinit Raut : 25-04-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing
                    frequency_specific_date: selectOrderOption?.selectSpecificFrequencyDate,  // BT-107418- 15/04/2024 - Vinit R - 28/03/2024 Breeze SIP order entry issues
                    frequency_monthly_option: selectOrderOption?.frequency,
                    no_of_installments: parseInt(orderInputs?.numberOfInstallment)
                },
                company_name: "",
                ltp: scripOrderInfo?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE],
                cap_price: String(orderInputs?.capPrice),
                invested_by: selectOrderOption?.orderBy === "Amount" ? "VALUE" :
                    selectOrderOption?.orderBy.toUpperCase(),
                quantity_or_value: String(orderInputs?.quantity),
                transaction_type: activeButtonToggleIndex === 0 ? 'BUY' : 'SELL',
                status: ALL_ORDERS_STATUS.ORDER_STATUS_PENDING,
                basket_name: "",
                sip_id: ""
                // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 -- End
            };

            objOrderStatusScripData = {
                scrip_info: {
                    exchange: getApiExchangeNameFromMktSegId(scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID]),
                    scrip_token: scripOrderInfo?.[WATCHLIST_GRID_INDEX.TOKEN],
                    symbol: scripOrderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL],
                    series: scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES],
                    expiry_date: "",
                    strike_price: "",
                    option_type: ""
                },
                selectOrderOption,
                transaction_type: activeButtonToggleIndex === 0 ? 'BUY' : 'SELL',
                product_type: '',
                order_type: selectOrderOption?.orderType,
                // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 -- Start
                price: parseFloat(orderInputs?.scripPrice),
                quantity: orderInputs?.quantity,
                cap_price: String(orderInputs?.capPrice),
                no_of_installments: parseInt(orderInputs?.numberOfInstallment)
                // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 -- End
            };

            dispatch(placeSipOrder(objSipReqPayload));
            // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
            if (isReOrder) {
                setTimeout(() => {
                    if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
                        dispatch(getAllSipOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }, isHistoryAllowed));
                    } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
                        dispatch(getAllSipOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }, isHistoryAllowed));

                    }
                }, 500);
            }
            // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
            setOrderEntryTab(ORDER_TYPES.SINGLE_SCRIP);

        }
    };

    // Parshva S - 15/11/2023 BT-102679 - Breeze- Multi Leg order entry - start
    const handleOnConfirmMultiLegOrder = () => {
        dispatch(updateMultiScripaddLEgModalTabKeyAction("futures"));
        const exchangeNameById = getApiExchangeNameFromMktSegId(arrInfo[0]?.extraInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]);

        var multiLegInfo =
        {
            "type": `${arrInfo?.length}L`,
            "validity": "IOC",
            // Adds condition to check if even 1 leg is RL-MKT then order is RL-MKT else order is RL if both legs are RL
            "order_type": arrInfo.some(legs => legs.orderType === ORDER_ENTRY_TYPES.RL_MKT) ? ORDER_ENTRY_TYPES.RL_MKT : ORDER_ENTRY_TYPES.RL,
            "prot_perc": "",
            "leg_details": []

        };
        multiLegInfo.leg_details = arrInfo?.map((element, i) => {
            return {
                leg_no: i + 1,
                transaction_type: element?.activeButtonToggleIndex === 0 ? "BUY" : "SELL",
                scrip_info: {
                    exchange: exchangeNameById,
                    scrip_token: element?.token,
                    symbol: element?.symbol?.trim(),
                    series: "XX",
                    expiry_date: moment(element?.expiryDate).format("DDMMMYYYY").toUpperCase(),
                    strike_price: element?.strikeprice === 'NA' ? "" : element?.strikeprice,
                    option_type: element?.optiontype === "NA" ? "" : element?.optiontype,
                    instrument_name: element?.instrument?.trim(),
                },
                // Ajitesh 18-09-2024 Adds OPTIDX condition to add proper qty while placing multileg order
                // quantity: arrInfo[0]?.instrument?.trim() === SCRIP_INSTRUMENTS.FUTSTK || arrInfo[0]?.instrument?.trim() === SCRIP_INSTRUMENTS.OPTSTK || arrInfo[0]?.instrument?.trim() === SCRIP_INSTRUMENTS.OPTIDX ? element?.count * element?.ask_qty : element?.count || 1, //Parshva S : 5/4/24 : BT 102679 Mltileg Order // Ajitesh 26-07-2024 Adds OPTSTK to condition to pass quantity size instead of lot for options orders (NSEFAO)
                quantity: arrInfo[0]?.extraInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSE_DERIVATIVES ? element?.count * element?.ask_qty : element?.count || 1, //Azeem K : 19-09-2024:added MARKET_SEGMENT_ID conditon instead of  SCRIP_INSTRUMENTS
                price: element?.legPrice,
                others: {
                    market_lot: element?.ask_qty,
                    price_tick: element?.priceTick, // AJitesh 30-07-2024 Adds price tick of element in case multileg has different scrips in case of commodity and currency
                    decimal_loc: element?.decLoc || arrInfo[0]?.extraInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                },
            };
        });
        dispatch(placeMultilegOrderAction(multiLegInfo))?.then((resp) => {
            if (resp?.status === NETWORK_RESPONSE_STATUS?.SUCCESS) {
                const orderId = resp?.data?.data?.orderId;
                dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': false }, { 'ORDER_ENTRY_MODAL': false }, { 'ORDER_STATUS': true }]));
                dispatch(handleModalData({ data: { orderId: orderId, orderEntryTab: 'multi_scrip', activeTabKey: 'multi_leg', objScripData: { ...multiLegInfo } } }));
                setOrderEntryTab(ORDER_TYPES.SINGLE_SCRIP);

            } else { }
        });
    };
    // Parshva S - 15/11/2023 BT-102679 - Breeze- Multi Leg order entry - end

    // margin info coming from api

    //Ameersha N : 21-08-2023 : BT-107070 - Breeze - Spread Order entry - Start
    const handleOnConfirmSpreadOrder = useCallback(() => {
        if (isModifyOrder) {
            dispatch(modifySpread(scripOrderInfo?.spreadOrderPayload, scripOrderInfo?.gatewayOrderNo)).then((resp) => {
                if (resp?.status === NETWORK_RESPONSE_STATUS?.SUCCESS) {
                    const orderId = resp?.data?.data?.orderId;
                    dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': false }, { 'ORDER_ENTRY_MODAL': false }, { 'ORDER_STATUS': true }]));
                    dispatch(handleModalData({ data: { orderId: orderId, orderEntryTab: 'multi_scrip', activeTabKey: 'spread', objScripData: { sellOrderHeading: scripOrderInfo?.sellOrderHeading, buyOrderHEading: scripOrderInfo?.buyOrderHEading, scripOrderInfo } } }), true);
                    setOrderEntryTab(ORDER_TYPES.SINGLE_SCRIP);
                    setTimeout(() => {
                        dispatch(getMessagesOrders({ pageNo: 1 }));
                    }, 2000);
                } else { }
            });
        } else {
            dispatch(placeMultilegOrderAction(scripOrderInfo?.spreadOrderPayload))?.then((resp) => {
                if (resp?.status === NETWORK_RESPONSE_STATUS?.SUCCESS) {
                    const orderId = resp?.data?.data?.orderId;
                    dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': false }, { 'ORDER_ENTRY_MODAL': false }, { 'ORDER_STATUS': true }]));
                    dispatch(handleModalData({ data: { orderId: orderId, orderEntryTab: 'multi_scrip', activeTabKey: 'spread', objScripData: { sellOrderHeading: scripOrderInfo?.sellOrderHeading, buyOrderHEading: scripOrderInfo?.buyOrderHEading, scripOrderInfo } } }), true);
                    setOrderEntryTab(ORDER_TYPES.SINGLE_SCRIP);

                } else { }
            });
        }
    }, [isModifyOrder, dispatch, scripOrderInfo, setOrderEntryTab]);
    //Ameersha N : 21-08-2023 : BT-107070 - Breeze - Spread Order entry - End

    // Ajitesh - 22/01/2024 - eDIS order cart implementation start
    const checkIfEdisValidationRequired = (arrOrderDetails, edisSummaryDetails) => {
        const hasUserGivenPOA = hasUserGrantedPOA();
        if (!hasUserGivenPOA && edisSummaryDetails) {
            const cartHasEdisScrips = edisSummaryDetails?.edis_summary?.filter(edisScrip => {
                return arrOrderDetails.find(cartScrip =>
                    cartScrip.isinCode === edisScrip.sISINCode &&
                    edisScrip.eDISRequestQty !== 0 &&
                    cartScrip.instrument === SCRIP_INSTRUMENTS.EQUITIES &&
                    cartScrip.sDefaultProductType === ORDER_PRODUCT_TYPES.DELIVERY &&
                    cartScrip.buySellType === 'SELL' //Ajitesh : 19/03/2024 : Edis issues while buying scrip
                );
            });
            if (cartHasEdisScrips?.length > 0) {
                // Ajitesh - 21/03/2024 Validation block to check if edis is needed or not needed
                let scripsThatRequireAuthentication = [];
                // Loop through order cart scrips
                arrOrderDetails.forEach(scrip => {
                    let sameScripFromEdisApi = cartHasEdisScrips.find(edisScripData => scrip.isinCode === edisScripData.sISINCode);
                    // Validation block for non AMO scrips in cart
                    if (scrip.amo === false) {
                        // If it finds same scrip present in edis api data
                        if (sameScripFromEdisApi !== undefined) {
                            if (Number(scrip.count) > sameScripFromEdisApi.ApprovedQuantity) {
                                scripsThatRequireAuthentication.push(sameScripFromEdisApi);
                            }
                        }
                    }
                    // Validation for non AMO
                    else {
                        if (sameScripFromEdisApi !== undefined) {
                            if (amoScripResponse.length) {
                                // check if AMO scrip is same as scrip in response
                                const scripFromResponse = amoScripResponse.filter(item => item.ISIN === scrip.isinCode);
                                if (Number(scrip.count) > scripFromResponse.Qty) {
                                    scripsThatRequireAuthentication.push(sameScripFromEdisApi);
                                }
                            }
                            else {
                                scripsThatRequireAuthentication.push(sameScripFromEdisApi);
                            }
                        }
                    }
                });
                if (scripsThatRequireAuthentication.length) {
                    setOrderCartScripsForEdis(scripsThatRequireAuthentication);
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    // Ajitesh - 22/01/2024 - eDIS order cart implementation end

    //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - Start
    const handleOnConfirmBasket = () => {
        //eachOrder.productType.includes(ORDER_PRODUCT_TYPES.DELIVERY) ? ORDER_PRODUCT_TYPES.DELIVERY : eachOrder.productType.includes(ORDER_PRODUCT_TYPES.MARGIN) && ORDER_PRODUCT_TYPES.INTRADAY  Removed after having conversation with Samadhan regarding product type : ManasaB : 24-04-2025
        let arrPayloadOrders = [];
        dispatch(saveCartForGoback({}));//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024
        arrOrderDetails.forEach((eachOrder) => {
            //BREEZE : 305 : Side tray Order Cart : ManasaB : 20-12-2024 : Taken product types from backend and Sl price sat issue - Start
            let scripPrice = eachOrder?.orderType === ORDER_ENTRY_TYPES.SL && eachOrder?.slLimit;
            let objOrderData = {
                quantity: eachOrder.count,
                transaction_type: eachOrder.buySellType,
                product_type: eachOrder.productType===ORDER_PRODUCT_TYPES.MARGIN ? ORDER_PRODUCT_TYPES.INTRADAY : (eachOrder.productType===ORDER_PRODUCT_TYPES.CARRYFORWARD ? ORDER_PRODUCT_TYPES.DELIVERY : eachOrder.productType),//ManasaB : 04-11-2025 : Product type issue
                order_type: eachOrder.orderType,
                is_amo: eachOrder.amo,
                order_identifier: objModalData?.data?.orderFrom === 'BASKETRECO' ? objModalData?.data?.orderIdentifier : `${objModalData.data.orderCartId}`, //ManasaB : 8190
                price: eachOrder.orderType === ORDER_ENTRY_TYPES.SL ? scripPrice : eachOrder.price, //BREEZE : 305 : Side tray Order Cart : ManasaB : 20-12-2024 : Taken product types from backend and Sl price sat issue - End,
                scrip_info: {
                    exchange: eachOrder.exchangeSegment,
                    expiry_date: eachOrder.expiryDate,
                    option_type: eachOrder.optionType,
                    scrip_token: eachOrder.token,
                    series: eachOrder.series,
                    strike_price: eachOrder.strikePrice,
                    symbol: eachOrder.symbol
                },
                trigger_price: eachOrder.slTrigger,
                validity: eachOrder.validity,
                validity_days: 0,
                displayProductType: eachOrder.productType
            };
            arrPayloadOrders.push(objOrderData);

        });
        const objBasketPayload = {
            ordercartName: objModalData.data.orderCartName,
            ordercartId: `${objModalData.data.orderCartId}`,
            orders: arrPayloadOrders

        };
        // Ajitesh - 22/01/2024 - eDIS order cart implementation validation block
        const requiresEdisValidation = checkIfEdisValidationRequired(arrOrderDetails, edisSummaryDetails);
        if (requiresEdisValidation) {
            dispatch(handleModal([{ "EDIS_PERMISSION_MODAL_ORDER_CART": true }], true));
        }
        else {
            dispatch(createOrderCartInfo(objBasketPayload))?.then((resp) => {
                //BT-106965 : Order Cart : ManasaB 17-07-2024 - Start
                if (resp?.status === API_RESPONSE_STATUS.SUCCESS) {
                    let arrOrderIds = resp?.data?.map(eachData => {
                        return { orderId: eachData?.data?.orderId };
                    });
                    dispatch(updateCartCount(1));
                    dispatch(updateBasketReco([]));
                    dispatch(saveCartForGoback({}));//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024
                    dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': false }, { 'ORDER_STATUS': true }]));
                    dispatch(handleModalData({ data: { arrOrderIds: arrOrderIds, orderEntryTab: 'multi_scrip', activeTabKey: 'basket', objScripData: { sellOrderHeading: scripOrderInfo?.sellOrderHeading, buyOrderHEading: scripOrderInfo?.buyOrderHEading } } }), true);
                    dispatch(saveCartSuccess(false));
                    dispatch(storeGridData([]));
                    setOrderEntryTab(ORDER_TYPES.SINGLE_SCRIP);
                }
                else {
                    dispatch((toastConfig({ autoDismiss: true, show: true, message: `Unable to place order, please try again later.` })));
                }
            });
            //BT-106965 : Order Cart : ManasaB 17-07-2024 -End
        }
    };
    //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - End
    const handleConfirmBtnOnClick = (e) => {
        e?.preventDefault();
        switch (orderEntryTab) {
            case ORDER_TYPES.SINGLE_SCRIP: {
                handleOnConfirmSingleScripOrder();
                break;
            }
            case ORDER_TYPES.EQUITY_SIP: {
                handleOnCofirmSipOrder();
                break;
            }
            case ORDER_TYPES?.MULTI_SCRIP: {
                if (orderEntryTab === ORDER_TYPES?.MULTI_SCRIP && activeTabKey === ORDER_TYPES?.SPREAD) {
                    handleOnConfirmSpreadOrder();
                } else if (orderEntryTab === ORDER_TYPES?.MULTI_SCRIP && activeTabKey === ORDER_TYPES?.MULTI_LEG) {
                    handleOnConfirmMultiLegOrder();
                }
                else if (orderEntryTab === ORDER_TYPES?.MULTI_SCRIP && activeTabKey === ORDER_TYPES.BASKET) {
                    handleOnConfirmBasket();
                }
                break;
            }
            default:
                break;
        }
    };

    useEffect(() => {
        // For SingleScrip Response Handling
        if (objSingleScripOrderResp?.status === API_RESPONSE_STATUS.SUCCESS) {
            const { data: { orderId } } = objSingleScripOrderResp;
            dispatch(handleModalData({ data: { orderId, objScripData: objOrderStatusScripData, scripOrderInfo, objSelectOrderOptionInit, orderEntryTab, selectOrderOption, orderInputs } }));
            dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': false }, { 'ORDER_STATUS': true }], true));
            setOrderInputs({ scripQuantity: 1, scripLot: 1, scripAmount: 0, scripPrice: '', slTrigger: 0, quantity: 0, capPrice: 0, numberOfInstallment: 0, intradayTrigger: 0, intradayLimit: 0, intradayTrailing: 0, intradayProfit: 0, discQty: 0, protPercent: 0, startDate: currentDate, gtdDate: defaultGtdDate, targetSelPrice: 0, targetSelTriggerPrice: 0 });// Azeem K : 07-05-2024 : BT-102298 Order Entry Production issues solved
        } else { }
    }, [dispatch, objSingleScripOrderResp]);

    useEffect(() => {
        // For SIP Response Handling
        if (objSipOrderResp?.status === API_RESPONSE_STATUS.SUCCESS) {
            dispatch(handleModalData({ data: { orderId: '', objScripData: objOrderStatusScripData, scripOrderInfo, objSelectOrderOptionInit, orderEntryTab } }));
            dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': false }, { 'ORDER_STATUS': true }], true));
        } else { }
    }, [dispatch, objSipOrderResp]);

    // useEffect(() => {
    //     // For Multi Leg Response Handling
    //     if (objMultiLegOrderResp?.data?.status == API_RESPONSE_STATUS.SUCCESS) {
    //         dispatch(handleModalData({ data: { orderId: objMultiLegOrderResp?.data?.data?.orderId, objScripData: objOrderStatusScripData, scripOrderInfo, objSelectOrderOptionInit, orderEntryTab } }));
    //         dispatch(handleModal([{ 'ORDER_STATUS': true }, { 'ORDER_ENTRY_CONFIRMATION': false }], true));
    //     } else { }
    // }, [dispatch, objMultiLegOrderResp]);

    useEffect(() => {
        if (orderEntryTab === ORDER_TYPES.EQUITY_SIP) {
            setBIsConfirmBtn(false);
        } else if (orderEntryTab === ORDER_TYPES.SINGLE_SCRIP) {
            if (bIsOrderEntryApiPending) {
                setBIsConfirmBtn(false);
            } else if (objSingleScripOrderResp?.status === API_RESPONSE_STATUS.ERROR) {
                setBIsConfirmBtn(false);
            } else {
                setBIsConfirmBtn(true);
            }

        }
    }, [orderEntryTab, objSingleScripOrderResp, bIsOrderEntryApiPending]);

    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

    // Ajitesh - 22/01/2024 - eDIS order cart implementation start
    // API call to get edis scrip data on refresh
    const getScripDataForEdis = () => {
        let mktSegmentId = MAPPED_MARKET_SEGMENT_ID.MAPPED_COMBINED_CASH;
        let token = -1;
        let productTypeForApi = "";
        const payload = {
            "mktSegmentId": mktSegmentId,
            "token": token,
            "productTypeForApi": productTypeForApi
        };
        dispatch(getEDISSummaryDetails(payload));
    };

    useEffect(() => {
        if (interopConfigDetails.length > 0) {
            interopConfigDetails.forEach((elem) => {
                if (elem.nInteropPreferredCCL !== -1 &&
                    elem.nCombinedSegmentId === MAPPED_MARKET_SEGMENT_ID.MAPPED_COMBINED_CASH &&
                    elem.sSegment === SEGMENT_CASH
                ) {
                    if (userDpDetails.data) {
                        // TODO: Check how we can determine if user has multiIsInEnabled with Rajendra
                        let isMultiIsinEnabled = getAppInfoData(APP_INFO_PARAMS.APP_MULTI_ISIN_NSDL);
                        if ((userDpDetails.data.sDepository === DEPOSITORY_CDSL ||
                            (userDpDetails.data.sDepository === DEPOSITORY_NSDL && isMultiIsinEnabled)) &&
                            userDpDetails.data.sDPId !== "" &&
                            userDpDetails.data.nBeneficiaryAccountNumber !== ""
                        ) {
                            getScripDataForEdis();
                        }
                    }
                }
            });
        }
    }, [interopConfigDetails, userDpDetails]);

    const handleEdisModalClose = useCallback(() => {
        dispatch(handleModal([{ "EDIS_PERMISSION_MODAL_ORDER_CART": false }, { "ORDER_ENTRY_CONFIRMATION": true }]));
        dispatch(handleModalData({ data: { orderCartConfirmation: objModalData.data.orderCartConfirmation, orderCartName: objModalData.data.orderCartName, orderEntryTab: 'multi_scrip', activeTabKey: 'basket' } }));
        dispatch(toastConfig({}));
        /*  Ajitesh - 23/03/2024
            Data refresh is no longer needed as data is refreshed when auth is completed and this component calls API on load for latest edis data in case user does not proceed to auth and closes modal.
            Check feasibility if needed later
        */
        //setDataRefreshed(true);
    }, [dispatch, objModalData]);
    // Ajitesh - 22/01/2024 - eDIS order cart implementation end

    // Ajitesh 22/03/2024 Logic to handle eDIS response from window obj for AMO sell
    const handleResponseForAmoSell = (response) => {
        setAmoScripResponse(response);
    };
    // Ajitesh 22/03/2024 Logic to handle eDIS response from window obj for AMO sell

    const OrderModalHeading = () => {
        return (
            <div data-testid='order-entry-confirmation-modal-heading' className='font-medium font-size4 color-text'>
                Confirm Your&nbsp;
                {
                    orderEntryTab === ORDER_TYPES.MULTI_SCRIP ? (
                        activeTabKey === ORDER_TYPES.MULTI_LEG ? ' Multileg '
                            :
                            activeTabKey === ORDER_TYPES.SPREAD ? ' Spread ' : ''
                    ) :
                        (
                            activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY ? <span className='color-positive'>Buy</span> : <span className='color-negative'>Sell</span>
                        )
                }
                &nbsp;Order
            </div>
        );
    };
    return (
        <>
            <BzModal show={modals['ORDER_ENTRY_CONFIRMATION']} onHide={handleClose} data-testid='order-entry-confirmation-modal'>
                <FocusLock className='focus-overflow'>
                    <form onSubmit={handleConfirmBtnOnClick}>
                        <BzModalHeader className='modaltabs-header'>
                            <Container fluid className='p-0'>
                                <Row className='g-0'>
                                    <Col md={11} className='d-flex justify-content-start align-items-center'>
                                        <OrderModalHeading />
                                    </Col>
                                    <Col md={1} className='d-flex justify-content-end align-items-center'>
                                        <div data-testid='order-entry-confirmation-modal-close-icon' className='icon-16 icon-dark icon-close' onClick={handleClose}></div>
                                    </Col>
                                </Row>
                            </Container>
                        </BzModalHeader>
                        <BzModalBody>
                            <ConfirmationBody layoutType={layoutType} orderEntryTab={orderEntryTab} activeTabKey={activeTabKey} activeButtonToggleIndex={activeButtonToggleIndex}
                                scripOrderInfo={scripOrderInfo} selectOrderOption={selectOrderOption} nOrderValue={nOrderValue} orderInputs={orderInputs} marginInfoHandler={marginInfoHandler}
                                bIsConfirmBtn={bIsConfirmBtn} setBIsConfirmBtn={setBIsConfirmBtn} arrMultiLegInfo={arrInfo} bIsCoverBracketOrderOpen={bIsCoverBracketOrderOpen} GTDNoOfDays={GTDNoOfDays} />
                            {
                                objMultiLegOrderResp?.response?.data?.status == API_RESPONSE_STATUS.ERROR &&
                                <Row className='p-0 py-3'>
                                    <Col className='d-flex justify-content-start'>
                                        <div data-testid='order-entry-confirmation-modal-error-message' className='error-msg text-wrap'>{objMultiLegOrderResp?.response.data.message}</div>
                                    </Col>
                                </Row>
                            }
                        </BzModalBody>
                        <BzModalFooter>
                            <Container fluid className='p-0'>
                                <Row className='g-0'>
                                    <Col md={8} className='mrgauto d-flex'>
                                        <BzButton data-testid='order-entry-confirmation-modal-go-back-button' className='btn btn-md btn-outline btn-block d-flex justify-content-center align-items-center me-3' onClick={handleGoBack}>
                                            <div className='icon-12 icon-backward-arrow icon-primary me-2'></div>
                                            <span className='font-medium'>Go Back</span>
                                        </BzButton>
                                        <BzButton data-testid='order-entry-confirmation-modal-confirm-button' autoFocus type='submit' className='btn btn-md btn-primary btn-block ms-3' disabled={!bIsConfirmBtn} >Confirm</BzButton>
                                    </Col>
                                </Row>
                            </Container>
                        </BzModalFooter>
                    </form>
                </FocusLock>
            </BzModal>

            {/* Ajitesh : 19/01/2024: BT-109135: order cart eDIS implementation - Start*/}
            <FocusLock className='focus-overflow'>
                <BzModal size="lg" show={modals["EDIS_PERMISSION_MODAL_ORDER_CART"]} onHide={handleEdisModalClose}>
                    <BzModalHeader className='modaltabs-header pb-0'>
                        <Container fluid className='p-0'>
                            <Row className='g-0'>
                                <Col className='d-flex justify-content-start align-items-end mb-2'>
                                    <BzModalTitle className='font-medium font-size6 color-text'>Edis Permission</BzModalTitle>
                                </Col>
                                <Col md={1} className='d-flex justify-content-end align-items-center mb-2'>
                                    <div onClick={handleEdisModalClose} className='icon-16 icon-close icon-dark ms-3' />
                                </Col>
                            </Row>
                        </Container>
                    </BzModalHeader>
                    <BzModalBody>
                        {/** NEED TO PASS SCRIPS from order cart that have eDIS pending and NOT ALL eDIS scrips */}
                        <Edis orderCartScripsForEdis={orderCartScripsForEdis} mode="orderCart" isAmo={false} handleResponseForAmoSell={(response) => handleResponseForAmoSell(response)} />
                    </BzModalBody>
                </BzModal>
            </FocusLock>
            {/* Ajitesh : 19/01/2024: BT-109135: order cart eDIS implementation - End*/}
        </>
    );
};

export default memo(ConfirmationModal);
